<script>
  import SharePreviewCardInternal from '../previews/SharePreviewCard.svelte';

  export let messages = [];
  export let compact = false;
</script>

<SharePreviewCardInternal {messages} {compact} />
